// extracted by mini-css-extract-plugin
export default {"select":"ReturnReasonSelect_select__0aB4j","selectWrapper":"ReturnReasonSelect_selectWrapper__6mbjE"};